
import Polkadot from "../../../assets/duotone/Polkadot.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PolkadotIcon({ className, dataTestid = "PolkadotIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Polkadot data-testid={dataTestid} className={classes} {...rest} />
  );
}
